// Company management module i18n - English
export default {
  source: {
    upstreamRemoved: 'Removed upstream; retained for linked manual accounts',
    detailReadOnly: 'MDM basic information and addresses are read-only. Responsibilities and default/reconciliation selections can be maintained locally.',
    label: 'Data source', manual: 'Manual', mdm: 'MDM', unknown: 'Unknown source', loading: 'Loading source',
    cargoware: 'CargoWare sync', cargowareHint: 'Data synchronized from CargoWare',
    manualHint: 'Manually maintained data can be edited', loadingHint: 'Editing is unavailable until the enterprise source is confirmed',
    mdmReadOnly: 'MDM data is read only. Maintain it in the source system.', unknownHint: 'The source is unspecified or unrecognized. Existing maintenance permissions apply.',
    unavailable: 'The enterprise source has not loaded successfully. Reload before editing.',
    viewFull: 'View full details'
  },
  /** 发送方客商关系上的运价分享开关。 */
  rateShare: {
    title: 'Rate sharing settings',
    enabled: 'Enable rate sharing',
    on: 'On',
    off: 'Off',
    tip: 'Enable sharing rates from your company to this customer. Turning it off stops new sharing and keeps previously shared rates.',
    confirmEnable: 'Enable rate sharing to this customer?',
    confirmDisable: 'Disable rate sharing to this customer? Previously shared rates will be kept.',
    saved: 'Rate sharing settings saved',
    saveFailed: 'Failed to save rate sharing settings',
    loadFailed: 'Failed to load rate sharing settings',
    reload: 'Reload'
  },
  title: 'Company Management',
  description: 'Manage company info, contacts, financial accounts, coordinators and freight levels',

  fields: {
    enterpriseName: 'Company Name',
    enterpriseNameEn: 'English Name',
    enterpriseCode: 'Company Code',
    businessLicense: 'Business License No.',
    businessLicenseFile: 'Business License',
    address: 'Company Address',
    addressDetail: 'Detailed Address',
    remark: 'Remark',
    status: 'Company Status',
    createTime: 'Created At',
    lastActive: 'Last Active',
    userCount: 'User Count',
    industry: 'Industry',
    scale: 'Company Scale',
    contacts: 'Contacts',
    contactName: 'Contact Name',
    contactPosition: 'Contact Position',
    contactPhone: 'Contact Phone',
    contactEmail: 'Contact Email',
    ifDefault: 'Default Contact',
    ifReconciliation: 'Reconciliation Contact',
    invoiceInfo: 'Invoice Info',
    dedicatedRelList: 'Company Coordinators',
    freightLevelConfigList: 'Freight Level Config',
    businessType: 'Business Type',
    freightLevel: 'Freight Level',
    action: 'Action',
    enterpriseId: 'Company ID',
    countryCode: 'Country Code',
    provinceCode: 'Province Code',
    cityCode: 'City Code',
    districtCode: 'District Code',
    streetCode: 'Street Code',
    enterpriseInfo: 'Company Info',
    contactInfo: 'Contact Info',
    users: 'Users',
    email: 'Company Email',
    actions: 'Actions',
    auditResult: 'Audit Result',
    auditReason: 'Audit Reason',
    audit: 'Audit',
    auditInfo: 'Pending Company Info',
    businessLicenseFileName: 'Business License.jpg',
    uploadTime: 'Upload Time',
    unknown: 'Unknown',
    addressCascader: 'Province/City/District/Street',
    contactMethod: 'Contact Method',
    userId: 'User ID',
    userInfo: 'User Info',
    role: 'Role',
    invoiceCompanyName: 'Company Name',
    invoiceTaxNo: 'Tax Number',
    invoiceAddress: 'Invoice Address',
    invoicePhone: 'Invoice Phone',
    invoiceBank: 'Bank Name',
    invoiceBankAccount: 'Bank Account',
    cnyAccountInfo: 'CNY Account',
    usdAccountInfo: 'USD Account',
    reconciliationContactName: 'Contact',
    reconciliationContactPosition: 'Position',
    reconciliationContactPhone: 'Phone',
    reconciliationContactEmail: 'Email',
    noReconciliationContact: 'No reconciliation contact set',
    cnyBankName: 'Bank Name',
    cnyBankAccount: 'Bank Account',
    cnyAccountName: 'Account Name',
    cnySwiftCode: 'SWIFT Code',
    cnyBankAddress: 'Bank Address',
    usdBankAccount: 'Bank Account',
    usdAccountName: 'Account Name',
    usdSwiftCode: 'SWIFT Code',
    usdBankAddress: 'Bank Address',
    reconciliationContact: 'Reconciliation Contact',
    contactPerson: 'Contact Person',
    noAddress: 'No address'
  },

  status: {
    all: 'All Status',
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    rejected: 'Rejected',
    unknown: 'Unknown',
    approved: 'Approved'
  },

  actions: {
    addCompany: 'Add Company',
    editCompany: 'Edit Company',
    deleteCompany: 'Delete Company',
    viewDetail: 'Detail',
    refresh: 'Refresh',
    save: 'Save',
    cancel: 'Cancel',
    addContact: 'Add Contact',
    editContact: 'Edit Contact',
    setDefault: 'Set as Default',
    addCoordinator: 'Add Coordinator',
    editCoordinator: 'Edit Coordinator',
    addUser: 'Add User',
    editUser: 'Edit User',
    audit: 'Audit',
    enable: 'Enable',
    disable: 'Disable',
    search: 'Search',
    copy: 'Copy',
    upload: 'Upload',
    preview: 'Preview',
    replace: 'Replace',
    select: 'Select',
    close: 'Close',
    back: 'Back',
    more: 'More',
    edit: 'Edit',
    viewUsers: 'Click to view related users',
    deleteContact: 'Delete Contact',
    editFinancial: 'Edit Financial Info',
    setAdmin: 'Set as Admin',
    remove: 'Remove',
    copyFromCny: 'Copy from CNY Account',
    copyFromInvoice: 'Copy from Invoice Info',
    delete: 'Delete',
    pendingAuditInfo: 'Pending Company Info',
    goBack: 'Back',
    submit: 'Submit Application',
    saveEdit: 'Save Changes',
    update: 'Update',
    confirm: 'Confirm'
  },

  forms: {
    searchPlaceholder: 'Search company name or contact',
    statusFilter: 'Status Filter',
    nameRequired: 'Please enter company name',
    englishNameRequired: 'Please enter English name',
    businessLicenseRequired: 'Please enter business license number',
    businessLicenseInvalid: 'Please enter a valid business license number (18 digits and letters)',
    addressRequired: 'Please select company address',
    detailAddressRequired: 'Please enter detailed address',
    contactNameRequired: 'Please enter contact name',
    contactPhoneOrEmailRequired: 'Contact phone and email must have at least one',
    contactPhoneInvalid: 'Please enter a valid contact phone',
    contactEmailInvalid: 'Please enter a valid email address',
    invoiceCompanyNameRequired: 'Please enter invoice company name',
    invoiceTaxNoRequired: 'Please enter tax number',
    invoiceAddressRequired: 'Please enter invoice address',
    invoicePhoneRequired: 'Please enter invoice phone',
    invoiceBankRequired: 'Please enter bank name',
    invoiceBankAccountRequired: 'Please enter bank account',
    cnyBankNameRequired: 'Please enter CNY bank name',
    cnyBankAccountRequired: 'Please enter CNY bank account',
    cnyAccountNameRequired: 'Please enter CNY account name',
    cnySwiftCodeRequired: 'Please enter SWIFT code',
    cnyBankAddressRequired: 'Please enter CNY bank address',
    reconciliationContactRequired: 'Please select reconciliation contact',
    remarkPlaceholder: 'Please enter remark (optional)',
    auditResultPlaceholder: 'Please select audit result',
    auditReasonPlaceholder: 'Please describe the reason and opinion in detail',
    contactNameMax: 'Up to 140 characters',
    contactNamePattern: 'Invalid format',
    contactPositionMax: 'Up to 140 characters',
    contactPositionPattern: 'Invalid format',
    contactPhoneMax: 'Up to 140 characters',
    contactPhonePattern: 'Invalid format',
    contactEmailMax: 'Up to 140 characters',
    contactEmailPattern: 'Please enter a valid email address format',
    invoicePhonePattern: 'Please enter a valid invoice phone number'
  },

  messages: {
    saveSuccess: 'Company info saved',
    saveSuccessRefreshHint:
      'Saved. If the page does not refresh, reload the browser (ensure enterprise-service and mdm-service are running).',
    saveFailed: 'Save failed, please check the form',
    deleteConfirm: 'Are you sure to delete this company?',
    deleteContent: 'All information of {name} will be lost after deletion',
    deleteSuccess: 'Company {name} deleted',
    addContactSuccess: 'Contact added',
    updateContactSuccess: 'Contact info updated',
    deleteContactSuccess: 'Contact deleted',
    setDefaultContactSuccess: 'Set as default contact',
    addCoordinatorSuccess: 'Coordinator added',
    updateCoordinatorSuccess: 'Coordinator info updated',
    deleteCoordinatorSuccess: 'Coordinator deleted',
    uploadSuccess: 'Upload successful',
    uploadFailed: 'Upload failed',
    aiFillSuccess: 'AI recognition succeeded, company info auto-filled',
    auditSuccess: 'Company audit completed',
    auditFailed: 'Company audit failed',
    refreshSuccess: 'Data refreshed',
    copySuccess: '{label} copied to clipboard',
    auditResultRequired: 'Please select audit result',
    auditReasonRequired: 'Please enter audit opinion',
    // index page related
    basicInfoValidationFailed: 'Basic information validation failed',
    contactDataFailed: 'Contact data retrieval failed',
    financialInfoFailed: 'Financial information data retrieval failed',
    submitSuccess: 'Submitted successfully',
    operationFailed: 'Operation failed',
    getListFailed: 'Failed to get company list',
    getStatsFailed: 'Failed to get company statistics',
    statusChanged: 'Company update status successfully',
    statusChangeFailed: 'Company update status Failed',
    auditSuccessWithResult: 'Company audit {result} successfully'
  },

  tabs: {
    basicInfo: 'Basic Info',
    contacts: 'Contacts',
    contactsList: 'Contacts List ({count})',
    financialInfo: 'Financial Info',
    coordinator: 'Coordinator',
    coordinatorList: 'Coordinator List ({count})',
    rateLevel: 'Customer Level',
    relatedUsers: 'Related Users',
    relatedUsersList: 'Related Users ({count})',
    thirdPartyAuth: 'Third-party Auth',
    wtfInfo: 'WTF Info',
    roleConfig: 'Role Configuration',
    mdmAttribute: 'MDM Attributes'
  },

  mdm: {
    import: 'MDM Customer Import',
    importResult: 'Import done: {success} succeeded, {fail} failed',
    importNoValidRows:
      'No valid rows found. Use the downloaded template, keep English headers (mdmCode, enterpriseName, etc.), and fill at least one row',
    importFileTooLarge: 'File size must not exceed 10MB',
    importFailed: 'MDM import failed',
    downloadFailExcel: 'Download failure details',
    downloadFailExcelTip: 'Some rows failed. Download failure Excel?',
    importFailFilename: 'mdm-customer-vendor-import-fail.xlsx',
    importTemplateFilename: 'mdm-customer-vendor-import-template.xlsx',
    templateDownloadFailed: 'Template download failed',
    shortName: 'Short Name',
    legalRepresentative: 'Legal Representative',
    mdmReadOnlyTip: 'Synced from MDM; update via master data system',
    yes: 'Yes',
    no: 'No',
    partnerCustomer: 'Customer',
    partnerSupplier: 'Supplier',
    tenantOnlyTitle: 'Shokz tenant only',
    tenantOnlySubtitle: 'Ensure custom.validation.enabled = shokz in Config Management',
    page: {
      title: 'MDM Customer & Vendor',
      subtitle: 'Shokz · Excel import and MDM attributes',
      importCardTitle: 'Batch Import',
      importDesc: 'Upload MDM Excel (.xlsx / .xls, max 10MB). Upsert by mdmCode.',
      downloadTemplate: 'Download template',
      selectExcelImport: 'Select Excel file',
      lastImport: 'Last import: {success} succeeded, {fail} failed',
      viewAttributeCardTitle: 'View MDM attributes',
      enterpriseIdLabel: 'Enterprise ID',
      enterpriseIdPlaceholder: 'Enter enterprise ID',
      viewMdmAttribute: 'View MDM attributes'
    },
    extensionPage: {
      title: 'Customer MDM Attributes',
      subtitle: 'Enterprise ID: {id}',
      noData: 'No MDM extension data',
      missingEnterpriseId: 'Enterprise ID is required',
      loadFailed: 'Failed to load MDM extension'
    },
    attribute: {
      readOnlyAlert: 'MDM fields are read-only. Changes must be synced from MDM.',
      generalTitle: 'General',
      customerTitle: 'Customer attributes',
      supplierTitle: 'Supplier attributes',
      receivingTitle: 'Receiving addresses',
      noReceivingAddress: 'No receiving address',
      receivingLoadFailed: 'Failed to load receiving addresses. Please retry.',
      addressTitle: 'Address {index}',
      primaryTag: 'Primary',
      mdmId: 'MDM ID',
      counterpartyCode: 'Counterparty code',
      counterpartyNature: 'Counterparty nature',
      mainCurrency: 'Main currency',
      cooperatingSubsidiary: 'Cooperating subsidiary',
      isInternalEntity: 'Internal entity',
      partnerTypes: 'Partner types',
      country: 'Country',
      provinceCity: 'Province / City',
      receivingCompany: 'Receiving company',
      detailAddress: 'Detail address',
      contactName: 'Contact',
      contactPhone: 'Phone',
      syncLogTitle: 'MDM sync log (latest 100)',
      syncTime: 'Received at',
      operationType: 'Operation',
      mdmCode: 'MDM code',
      result: 'Result',
      success: 'Success',
      fail: 'Failed',
      errorMessage: 'Error',
      customerId: 'Customer ID',
      customerStatus: 'Customer status',
      salesMode: 'Sales mode',
      customerCategory: 'Customer category',
      regionLevelOne: 'Region L1',
      regionLevelTwo: 'Region L2',
      regionLevelThree: 'Region L3',
      salesRepresentative: 'Sales rep',
      tradeTerms: 'Trade terms',
      taxRate: 'Customer tax rate',
      isTemporarySupplier: 'Temporary supplier',
      supplierStatus: 'Supplier status',
      supplierPaymentDays: 'Payment days',
      supplierTaxRate: 'Supplier tax rate',
      responsibleBusinessPerson: 'Responsible person'
    },
    bankAccount: {
      title: 'Bank accounts',
      accountCount: '{count} account(s)',
      addAccount: 'Add account',
      currency: 'Currency',
      bankName: 'Bank name',
      bankAccount: 'Account no.',
      accountName: 'Account name',
      swiftCode: 'SWIFT',
      bankCountry: 'Bank country',
      bankAddress: 'Bank address',
      action: 'Action',
      deleteAccount: 'Remove account'
    }
  },

  breadcrumb: {
    platformAdmin: 'Platform Admin'
  },

  stats: {
    totalCompanies: 'Total Companies'
  },

  tips: {
    rateLevel: 'Set the visible freight level for each business type. E.g.: FCL--T0, LCL--T2'
  },

  modals: {
    licensePreview: 'Business License Preview',
    noLicense: 'No business license',
    uploadLicenseTip: 'Please upload the business license file first',
    uploadLicense: 'Upload License',
    uploadLicenseReq: 'Upload requirements:',
    uploadLicensePhoto: '• Please upload a clear photo or scan of the business license',
    uploadLicenseFormat: '• Supports JPG, PNG, PDF formats',
    uploadLicenseSize: '• File size should not exceed 10MB',
    uploadLicenseResolution: '• Recommended resolution not less than 1024×768',
    uploadLicenseDrag: 'Click to select or drag file here',
    uploadLicenseDragTip1: 'Drag the business license file to this area',
    uploadLicenseDragTip2: 'Or click to select file to upload, AI will auto-recognize company info'
  },

  enum: {
    status: {
      pending: 'Pending',
      active: 'Active',
      rejected: 'Rejected',
      disabled: 'Disabled'
    },
    dedicatedType: {
      operation: 'Dedicated Operation',
      sales: 'Dedicated Sales',
      service: 'Dedicated Service',
      document: 'Dedicated Document',
      business: 'Dedicated Business',
      finance: 'Dedicated Finance'
    },
    freightLevel: {
      T0: 'T0 Level',
      T1: 'T1 Level',
      T2: 'T2 Level',
      T3: 'T3 Level'
    },
    businessType: {
      FCL: 'FCL (Full Container Load)',
      LCL: 'LCL (Less than Container Load)',
      AIR: 'Air Freight',
      RAIL: 'Rail Freight',
      PRECARRIAGE: 'Precarriage',
      LASTMILE: 'Last Mile'
    },
    inviteStatus: {
      pendingJoin: 'Pending Join',
      joined: 'Joined',
      invalid: 'Invalid',
      expired: 'Expired'
    },
    joinEnterpriseAuditStatus: {
      PENDING: 'Pending',
      APPROVED: 'Approved',
      REJECTED: 'Rejected'
    }
  },

  profile: {
    loading: 'Loading company info...',
    uncertifiedTitle: 'Company not certified',
    uncertifiedDesc: 'Please certify or join a company first',
    certifyNewTitle: 'Certify New Company',
    certifyNewDesc: 'Submit info to create a new company and become admin',
    certifyNow: 'Certify Now',
    joinExistTitle: 'Join Existing Company',
    joinExistDesc: 'Join a certified company via invite code or admin invitation',
    joinNow: 'Apply to Join',
    bindThirdTitle: 'Bind Third-party Tenant',
    bindThirdDesc: 'Bind an existing third-party tenant to sync info and permissions',
    bindNow: 'Start Binding',
    pendingTitle: 'Company Certification Pending',
    pendingDesc: 'Your application is under review, expected 1-3 working days',
    rejectedTitle: 'Company Certification Rejected',
    rejectedDesc: 'Sorry, your application was not approved',
    resubmit: 'Resubmit',
    infoTitle: 'Company Info',
    edit: 'Edit',
    managementTitle: 'Employee Management',
    inviteTab: 'Invite Management',
    applicationTab: 'Application Review',
    inviteTabDesc:
      'Generate invite links for employees to join the company. Each link is valid for 48 hours.',
    applicationTabDesc:
      'Review user applications to join the company. Approved users will be added to the company.',
    inviteBtn: 'Invite Employee',
    inviteCode: 'Invite Code',
    inviteEmail: 'Invite Email',
    inviteLink: 'Invite Link',
    inviteStatus: 'Status',
    inviteCreateTime: 'Created At',
    inviteExpireTime: 'Valid Until',
    inviteAction: 'Action',
    inviteCancel: 'Cancel',
    applicationUser: 'User Info',
    applicationInfo: 'Application Info',
    applicationStatus: 'Status',
    applicationAction: 'Action',
    applicationApprove: 'Approve',
    applicationReject: 'Reject',
    applicationPhone: 'Phone',
    applicationEmail: 'Email',
    applicationTime: 'Application Time',
    applicationMessage: 'Application Message',
    applicationRejectReason: 'Rejection Reason',
    joinModalTitle: 'Join Company',
    joinType: 'Join Method',
    hasInviteCode: 'Have Invite Code',
    noInviteCode: 'Apply without Invite Code',
    inviteCodePlaceholder: 'Please enter invite code',
    joinEnterpriseName: 'Company Name',
    joinEnterpriseNamePlaceholder: 'Please enter company name',
    joinApplyMessage: 'Application Note',
    bindModalTitle: 'Bind Third-party Tenant',
    thirdSystem: 'Third-party System',
    thirdSystemPlaceholder: 'Please select third-party system',
    tenantId: 'Tenant ID',
    tenantIdPlaceholder: 'Please enter tenant ID',
    tenantName: 'Tenant Name',
    tenantNamePlaceholder: 'Please enter tenant name',
    apiKey: 'API Key',
    apiKeyPlaceholder: 'Please enter API key',
    remark: 'Remark',
    remarkPlaceholder: 'Optional remark',
    inviteModalTitle: 'Invite Link',
    inviteCodeLabel: 'Invite Code:',
    inviteLinkLabel: 'Invite Link:',
    sendInviteMail: 'Send Invite Email',
    inviteMailPlaceholder: 'Please enter email address',
    sendMailBtn: 'Send Email',
    joinSuccess: 'Application submitted',
    joinApplySuccess: 'Application submitted, please wait for approval',
    joinFail: 'Failed to join company',
    bindSuccess: 'Third-party tenant bound successfully',
    bindFail: 'Failed to bind third-party tenant',
    generateInviteFail: 'Failed to generate invite link',
    inviteMailSuccess: 'Invite email sent successfully',
    inviteMailFail: 'Failed to send invite email',
    emailRequired: 'Please enter email address',
    inviteLinkRequired: 'Please generate invite link first',
    joinModalTip:
      'Please select your join method. If you have an invite code, you can join directly. Otherwise, you need to apply for approval.',
    joinTypeRadioWithCode: 'I have an invite code',
    joinTypeRadioNoCode: 'I do not have an invite code',
    joinInviteCodeLabel: 'Invite Code',
    joinInviteCodePlaceholder: 'Please enter the company invite code',
    joinCompanyNameLabel: 'Company Full Name',
    joinCompanyNamePlaceholder: 'Please enter the full company name (exact match required)',
    joinApplyMessageLabel: 'Application Note',
    joinApplyMessagePlaceholder: 'Please briefly state your reason for joining this company',
    joinModalOk: 'Submit Application',
    joinModalCancel: 'Cancel',
    infoCardTitle: 'Enterprise Certification Application',
    infoCardStatusApproved: 'Approved',
    infoCardStatusRejected: 'Rejected',
    infoCardStatusPending: 'Pending',
    infoCardStatusUncertified: 'Uncertified',
    infoCardCompanyName: 'Company Name',
    infoCardCompanyNameEn: 'English Name',
    infoCardBusinessLicense: 'Business License No.',
    infoCardSubmitTime: 'Submit Time',
    infoCardRejectReason: 'Rejection Reason',
    infoCardApprovedTip: '✅ Congratulations! Certification Approved',
    infoCardApprovedDesc:
      'Your company has been certified. You can now manage company info and invite employees.',
    infoCardManageBtn: 'Manage Company Info',
    // Application management related
    applicationUserName: 'User Name',
    applicationUserPhone: 'Phone Number',
    applicationUserEmail: 'Email Address',
    applicationApplyTime: 'Application Time',
    applicationApproveBtn: 'Approve',
    applicationRejectBtn: 'Reject',
    applicationRejectModalTitle: 'Reject Application',
    applicationRejectModalWarning:
      '⚠️ After rejection, the user will not be able to join the company through this application. Please proceed with caution.',
    applicationRejectModalApplicant: 'Applicant',
    applicationRejectModalReasonLabel: 'Rejection Reason',
    applicationRejectModalReasonPlaceholder:
      'Please provide the reason for rejection. The applicant will be notified.',
    applicationRejectModalOk: 'Confirm Reject',
    applicationRejectModalCancel: 'Cancel',
    applicationRejectModalReasonRequired: 'Please enter the rejection reason',
    applicationApproveSuccess: 'Application approved',
    applicationRejectSuccess: 'Application rejected',
    applicationRejectReasonRequired: 'Please enter rejection reason'
  },

  basic: {
    status: 'Company Status',
    pending: 'Pending Review',
    enterpriseName: 'Company Name',
    enterpriseNameRequired: 'Please enter the company name',
    enterpriseNamePlaceholder: 'Please enter the company name',
    enterpriseNameMaxLength: 'Company name can be up to 70 Chinese characters (140 characters)',
    enterpriseNamePattern:
      'Company name can only contain Chinese characters, numbers, brackets, commas, quotes, hyphens, periods, and spaces',
    enterpriseNameEn: 'English Name',
    enterpriseNameEnRequired: 'Please enter the English name',
    enterpriseNameEnPlaceholder: 'Please enter the English name',
    enterpriseNameEnMaxLength: 'English name can be up to 140 characters',
    enterpriseNameEnPattern:
      'English name can only contain uppercase and lowercase letters, spaces, commas, dots, brackets, hyphens, slashes, numbers, and quotes',
    businessLicense: 'Business License No.',
    businessLicenseRequired: 'Please enter the business license number',
    businessLicenseInvalid: 'Please enter a valid business license number (18 digits and letters)',
    businessLicensePlaceholder: 'Please enter the 18-digit business license number',
    businessLicenseMaxLength: 'Business license number can be up to 30 characters',
    businessLicensePattern:
      'Business license number can only contain uppercase and lowercase letters, spaces, commas, dots, brackets, hyphens, slashes, numbers, and quotes',
    businessLicenseFile: 'Business License',
    businessLicenseFileRequired: 'Please upload the business license file',
    businessLicenseFileFormat: 'Only JPG, PNG, PDF formats are supported',
    businessLicenseFileSize: 'File size cannot exceed 10MB',
    remark: 'Remark',
    remarkMaxLength: 'Remark can be up to 1000 characters',
    businessLicenseFileName: 'Business License.jpg',
    uploadTime: 'Upload Time',
    unknown: 'Unknown',
    preview: 'Preview',
    replace: 'Replace',
    uploadLicense: 'Upload Business License',
    uploadLicenseModal: 'Upload Business License',
    uploadLicenseReq: 'Upload requirements:',
    uploadLicensePhoto: '• Please upload a clear photo or scan of the business license',
    uploadLicenseFormat: '• Supports JPG, PNG, PDF formats',
    uploadLicenseSize: '• File size should not exceed 10MB',
    uploadLicenseResolution: '• Recommended resolution not less than 1024×768',
    uploadLicenseDrag: 'Click to select or drag file here',
    uploadLicenseDragTip1: 'Drag the business license file to this area',
    uploadLicenseDragTip2: 'Or click to select file to upload, AI will auto-recognize company info',
    aiRecognizing: 'AI Recognition...',
    aiRecognizingDesc: 'Intelligently recognizing business license information, please wait',
    recognitionSuccess: 'Recognition Successful!',
    recognitionSuccessDesc1: 'Successfully recognized business license information',
    recognitionSuccessDesc2: 'Company name, license number and other info auto-filled',
    uploadSuccess: 'Business license uploaded successfully',
    uploadFailed: 'Upload failed',
    delete: 'Delete',
    deleteSuccess: 'Business license deleted successfully',
    close: 'Close',
    cancel: 'Cancel',
    country: 'Country',
    countryRequired: 'Please select a country',
    countryPlaceholder: 'Please select a country',
    province: 'Province',
    provincePlaceholder: 'Please select a country',
    city: 'City',
    cityPlaceholder: 'Please select a city',
    district: 'District',
    districtPlaceholder: 'Please select a district',
    street: 'Street',
    streetPlaceholder: 'Please select a street',
    addressCascader: 'Company Address (Province/City/District/Street)',
    addressCascaderRequired: 'Please select the company address',
    addressCascaderPlaceholder: 'Please select province, city, district, street',
    detailAddress: 'Detailed Address',
    detailAddressRequired: 'Please enter the detailed address',
    detailAddressPlaceholder: 'Please enter the detailed address',
    detailAddressMaxLength: 'Detailed address can be up to 280 characters',
    detailAddressPattern:
      'Detailed address can only contain Chinese characters, uppercase and lowercase letters, spaces, commas, dots, brackets, hyphens, slashes, numbers, and quotes',
    remarkPlaceholder: 'Please enter remarks (optional)',
    licensePreview: 'Business License Preview',
    noLicense: 'No business license file',
    countryListError: 'Failed to get country list',
    countrySearchError: 'Country search failed',
    filePreviewNotSupported: 'This file type does not support preview',
    fileDownloaded: 'File downloaded',
    fileDownloadFailed: 'File download failed'
  },
  contact: {
    basicInfo: 'Basic Information',
    enableResponsibilityScope: 'Enable Responsibility Scope',
    responsibilitySettings: 'Responsibility Settings',
    listTitle: 'Contact List ({count})',
    add: 'Add Contact',
    edit: 'Edit Contact',
    delete: 'Delete Contact',
    default: 'Default',
    setDefault: 'Set as Default',
    setDefaultConfirmTitle: 'Confirm Set as Default Contact',
    setDefaultConfirm: 'Are you sure you want to set {name} as the default contact?',
    currentDefault: 'The current default contact {name} will be unset',
    notice: 'Note:',
    deleteConfirmTitle: 'Confirm Delete Contact',
    deleteConfirm: 'Are you sure you want to delete contact {name}?',
    deleteIrreversible: 'This action is irreversible, please proceed with caution',
    name: 'Contact Name',
    nameRequired: 'Please enter the contact name',
    namePlaceholder: 'Please enter the contact name',
    nameMaxLength: 'Contact name can be up to 140 characters',
    namePattern:
      'Contact name can only contain Chinese characters, uppercase and lowercase letters, numbers, brackets, commas, quotes, and hyphens',
    title: 'Contact Position',
    jobTitle: 'Job Title',
    jobTitlePlaceholder: 'Enter job title',
    addressSection: 'Contact Addresses',
    addAddress: 'Add Address',
    isShippingAddress: 'Shipping Address',
    country: 'Country/Region',
    province: 'State/Province',
    city: 'City',
    detailAddress: 'Detail Address',
    titlePlaceholder: 'Please enter the contact position',
    titleMaxLength: 'Contact position can be up to 140 characters',
    titlePattern:
      'Contact position can only contain Chinese characters, uppercase and lowercase letters, numbers, brackets, commas, quotes, and hyphens',
    phone: 'Contact Phone',
    phoneRequired: 'Please enter the contact phone',
    phoneInvalid: 'Please enter a valid phone number',
    phonePlaceholder: 'Please enter mobile number',
    phoneMaxLength: 'Contact phone can be up to 140 characters',
    phonePattern: 'Invalid phone number format',
    email: 'Email Address',
    emailRequired: 'Please enter the email address',
    emailInvalid: 'Please enter a valid email address',
    emailPlaceholder: 'Please enter the email address',
    emailMaxLength: 'Email address can be up to 140 characters',
    emailPattern:
      'Email address can only contain numbers, brackets, commas, quotes, hyphens, plus signs, @, letters, and dots',
    phoneOrEmailRequired: 'Please enter either phone number or email address',
    wechatWorkRpaGroupName: 'WeChat Work Group Name (RPA)',
    wechatWorkRpaGroupNamePlaceholder: 'Please enter WeChat Work group name',
    wechatWorkRpaGroupNameMaxLength: 'WeChat Work group name can be up to 255 characters',
    containerLoadType: 'Container Load Type',
    containerLoadTypePlaceholder: 'Please select container load type (multiple)',
    containerLoadTypeMaxLength: 'Container load type can be up to 500 characters',
    routeRange: 'Route Range',
    routeRangePlaceholder: 'Please select routes (multiple)',
    routeRangeMaxLength: 'Route range can be up to 500 characters',
    loadingPortRange: 'Loading Port Range',
    loadingPortRangePlaceholder: 'Please select loading ports (multiple)',
    loadingPortRangeMaxLength: 'Loading port range can be up to 500 characters',
    carrierRange: 'Carrier Range',
    carrierRangePlaceholder: 'Please select carriers (multiple)',
    carrierRangeMaxLength: 'Carrier range can be up to 500 characters',
    contactInfo: 'Contact Information',
    contactMethod: 'Contact Method',
    action: 'Action',
    confirm: 'Confirm',
    cancel: 'Cancel',
    confirmSetDefault: 'Confirm Set',
    confirmDelete: 'Confirm Delete',
    updateSuccess: 'Contact information updated',
    addSuccess: 'Contact added',
    setDefaultSuccess: 'Default contact set',
    deleteSuccess: 'Contact deleted',
    noContacts: 'Please add at least one contact',
    noDefaultContact: 'Please set a default contact',
    formValidationFailed: 'Contact form validation failed',
    cannotDeleteReconciliation:
      '{name} is the reconciliation contact person. Please cancel and try again',
    combinationConflict:
      'The combination of container load types, route range, and carrier range conflicts with contact {name}. Please modify and try again'
  },
  financial: {
    invoiceInfo: 'Invoice Information',
    copyAll: 'Copy All',
    companyName: 'Company Name:',
    taxNumber: 'Tax Number',
    invoiceAddress: 'Invoice Address',
    invoicePhone: 'Invoice Phone',
    bankName: 'Bank Name',
    bankAccount: 'Bank Account',
    cnyAccount: 'CNY Account',
    accountName: 'Account Name',
    swiftCode: 'SWIFT Code:',
    bankAddress: 'Bank Address',
    usdAccount: 'USD Account',
    reconciliationContact: 'Reconciliation Contact',
    addInvoice: 'Add invoice info',
    deleteInvoiceRow: 'Remove invoice',
    contact: 'Contact:',
    position: 'Position:',
    phone: 'Phone:',
    email: 'Email:',
    noReconciliationContact: 'No reconciliation contact set',
    edit: 'Edit Financial Information',
    invoiceInfoRequired: 'Invoice information (required)',
    cnyAccountRequired: 'CNY account (required)',
    usdAccountOptional: 'USD account (optional)',
    // 新增表单字段
    invoiceCompanyName: 'Company Name',
    invoiceCompanyNameRequired: 'Please enter the invoice company name',
    invoiceCompanyNamePlaceholder: 'Please enter the invoice company name',
    invoiceCompanyNameMaxLength: 'Company name can be up to 140 characters',
    invoiceCompanyNamePattern:
      'Company name can only contain Chinese characters, numbers, brackets, commas, quotes, and hyphens',
    invoiceTaxNumber: 'Tax Number',
    invoiceTaxNumberRequired: 'Please enter the tax number',
    invoiceTaxNumberPlaceholder: 'Please enter the tax number',
    invoiceTaxNumberPattern:
      'Tax number can only contain uppercase and lowercase letters, spaces, commas, dots, brackets, hyphens, slashes, numbers, and quotes, up to 30 characters',
    invoiceAddressRequired: 'Please enter the invoice address',
    invoiceAddressPlaceholder: 'Please enter the invoice address',
    invoiceAddressMaxLength: 'Invoice address can be up to 280 characters',
    invoiceAddressPattern:
      'Invoice address can only contain Chinese characters, numbers, brackets, commas, quotes, and hyphens',
    invoicePhoneRequired: 'Please enter the invoice phone',
    invoicePhonePlaceholder: 'Please enter the invoice phone',
    invoicePhonePattern:
      'Invoice phone can only contain numbers, brackets, commas, quotes, hyphens, and plus signs, up to 140 characters',
    invoiceBankName: 'Bank Name',
    invoiceBankNameRequired: 'Please enter the bank name',
    invoiceBankNamePlaceholder: 'Please enter the bank name',
    invoiceBankNameMaxLength: 'Bank name can be up to 140 characters',
    invoiceBankNamePattern:
      'Bank name can only contain Chinese characters, numbers, brackets, commas, quotes, and hyphens',
    invoiceBankAccount: 'Bank Account',
    invoiceBankAccountRequired: 'Please enter the bank account',
    invoiceBankAccountPlaceholder: 'Please enter the bank account',
    invoiceBankAccountPattern: 'Bank account can only contain numbers, up to 30 digits',
    cnyBankName: 'Bank Name',
    cnyBankNameRequired: 'Please enter the bank name',
    cnyBankNamePlaceholder: 'Please enter the bank name',
    cnyBankNameMaxLength: 'Bank name can be up to 140 characters',
    cnyBankNamePattern:
      'Bank name can only contain Chinese characters, numbers, brackets, commas, quotes, and hyphens',
    cnyBankAccount: 'Bank Account',
    cnyBankAccountRequired: 'Please enter the bank account',
    cnyBankAccountPlaceholder: 'Please enter the bank account',
    cnyBankAccountPattern: 'Bank account can only contain numbers, up to 30 digits',
    cnyAccountName: 'Account Name',
    cnyAccountNameRequired: 'Please enter the account name',
    cnyAccountNamePlaceholder: 'Please enter the account name',
    cnyAccountNameMaxLength: 'Account name can be up to 140 characters',
    cnyAccountNamePattern:
      'Account name can only contain Chinese characters, numbers, brackets, commas, quotes, and hyphens',
    cnySwiftCode: 'SWIFT Code',
    cnySwiftCodeRequired: 'Please enter the SWIFT code',
    cnySwiftCodePlaceholder: 'Please enter the SWIFT code',
    cnySwiftCodePattern: 'SWIFT code can only contain uppercase letters, numbers, and hyphens',
    cnyBankAddress: 'Bank Address',
    cnyBankAddressRequired: 'Please enter the bank address',
    cnyBankAddressPlaceholder: 'Please enter the bank address',
    cnyBankAddressMaxLength: 'Bank address can be up to 280 characters',
    cnyBankAddressPattern:
      'Bank address can only contain Chinese characters, numbers, brackets, commas, quotes, and hyphens',
    usdBankName: 'Bank Name',
    usdBankNamePlaceholder: 'Please enter the bank name',
    usdBankNameMaxLength: 'Bank name can be up to 140 characters',
    usdBankNamePattern:
      'Bank name can only contain uppercase and lowercase letters, spaces, commas, dots, brackets, hyphens, slashes, numbers, and quotes',
    usdBankAccount: 'Bank Account',
    usdBankAccountPlaceholder: 'Please enter the bank account',
    usdBankAccountPattern: 'Bank account can only contain numbers, up to 30 digits',
    usdAccountName: 'Account Name',
    usdAccountNamePlaceholder: 'Please enter the English account name',
    usdAccountNameMaxLength: 'Account name can be up to 140 characters',
    usdAccountNamePattern:
      'Account name can only contain uppercase and lowercase letters, spaces, commas, dots, brackets, hyphens, slashes, numbers, and quotes',
    usdSwiftCode: 'SWIFT Code',
    usdSwiftCodePlaceholder: 'Please enter the SWIFT code',
    usdSwiftCodePattern: 'SWIFT code can only contain uppercase letters, numbers, and hyphens',
    usdBankAddress: 'Bank Address',
    usdBankAddressPlaceholder: 'Please enter the bank address',
    usdBankAddressMaxLength: 'Bank address can be up to 280 characters',
    usdBankAddressPattern:
      'Bank address can only contain uppercase and lowercase letters, spaces, commas, dots, brackets, hyphens, slashes, numbers, and quotes',
    reconciliationContactSelect: 'Select Reconciliation Contact',
    reconciliationContactRequired: 'Please select a reconciliation contact',
    reconciliationContactSelectPlaceholder: 'Please select a reconciliation contact',
    copyFromCnyToInvoice: 'Copy from CNY Account',
    copyFromInvoiceToCny: 'Copy from Invoice Info',
    save: 'Save',
    cancel: 'Cancel',
    copySuccess: '{label} copied to clipboard',
    copyFailed: 'Copy failed, please copy manually',
    cnyAccountInfo: 'CNY Account Information',
    usdAccountInfo: 'USD Account Information',
    copyFromInvoiceToCnySuccess: 'Invoice information copied to CNY account',
    copyFromCnyToInvoiceSuccess: 'CNY account information copied to invoice',
    saveSuccess: 'Financial information saved',
    saveFailed: 'Please check if the financial information is correct',
    formValidationFailed: 'Financial form validation failed',
    invoiceInfoIncomplete: 'Please complete the invoice information',
    cnyAccountIncomplete: 'Please complete the CNY account information'
  },
  coordinator: {
    tabTitle: 'Coordinator List ({count})',
    add: 'Add Coordinator',
    addEdit: 'Add Coordinator',
    edit: 'Edit Coordinator',
    type: 'Type',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    action: 'Action',
    editAction: 'Edit',
    deleteAction: 'Delete',
    selectTypePlaceholder: 'Please select coordinator type',
    typeLabel: 'Coordinator Type',
    staffLabel: 'Staff',
    selectStaffPlaceholder: 'Please select staff',
    cancel: 'Cancel',
    confirm: 'Confirm',
    duplicateTypeError: 'A coordinator of the same type already exists',
    typeRequired: 'Please select coordinator type',
    staffRequired: 'Please select staff'
  },
  relatedUser: {
    add: 'Add User',
    thirdPartySync: 'Third-party Sync',
    detail: 'Detail',
    setAdmin: 'Set as Admin',
    remove: 'Remove',
    superAdmin: 'Super Admin',
    user: 'User',
    syncTitle: 'Third-party User Sync',
    selectSystem: 'Please select an authorized third-party system',
    erp: 'ERP System',
    wms: 'WMS System',
    oms: 'OMS System',
    startSync: 'Start Sync',
    cancel: 'Cancel',
    syncing: 'Syncing user data, please wait...',
    syncingDesc: 'Estimated 5 seconds to complete sync',
    syncSuccess: 'User sync completed',
    addUserDev: 'Add user feature under development...',
    viewUserDetail: 'View user detail: {name}',
    setAdminSuccess: '{name} has been set as admin',
    removeUserSuccess: 'User removed: {name}',
    openSyncModal: 'Open third-party sync modal',
    syncComplete: 'Third-party user sync completed',
    addUserModalTitle: 'Add User',
    addUserModalDesc: 'Please select users to add to the company:',
    confirmAdd: 'Confirm Add',
    selectedCount: '{count} users selected',
    email: 'Email',
    phone: 'Phone',
    contact: 'Contact',
    status: 'Status',
    lastLogin: 'Last Login',
    id: 'ID',
    noAvailableUser: 'No available users',
    avatar: 'Avatar',
    setAdminModalTip:
      'Each tenant can only have one super admin. After setting {name} as super admin, the previous super admin will be demoted to normal user.',
    setAdminModalWarning:
      '⚠️ This operation will affect user permissions in the company. Please proceed with caution.',
    removeUserConfirmTitle: 'Remove User Confirmation',
    removeUserConfirmTip: 'Are you sure you want to remove user {name}?',
    removeUserConfirmNotice: 'Notice',
    removeUserConfirmDesc:
      'After removal, this user will not be able to access any features of this company. This action cannot be undone.',
    confirmRemove: 'Confirm Remove'
  },
  rateLevelTab: {
    desc: 'Set the visible freight level for each business type. E.g.: FCL--T0, LCL--T2'
  },
  roleConfig: {
    assignedRolesTitle: 'Assigned Roles ({count})',
    atLeastOneRole: 'At least one role is required',
    saveRoleRequired: 'Add at least one enterprise role under Role Configuration before saving',
    addRole: 'Add Role',
    selectRole: 'Select Role',
    addAll: 'Add All',
    cancel: 'Cancel',
    add: 'Add',
    roleAddedSuccess: '{count} roles added',
    roleRemovedSuccess: '{name} Role removed',
    allRolesAssigned: 'All available roles are assigned',
    configDescription: '💡 Role Configuration Instructions:',
    configTip1: '• Each enterprise needs at least one role configured',
    configTip2: '• You can select existing roles from role permission management',
    configTip3: '• Role permissions are configured by system administrators in role management',
    configTip4:
      '• Enterprise users will receive corresponding system permissions based on assigned roles',
    noRoles: 'No roles assigned, please click "Add Role" to configure',
    createTime: 'Created: ',
    loadRolesError: 'Failed to load available roles'
  }
}
